/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListOrganicTrafficSeriesOptions,
  ListOrganicTrafficSeriesResponses,
} from '../types/ListOrganicTrafficSeries'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. One point per interval, oldest first. The traffic figures are summed over the metric buckets, which do not overlap. The assessment figures are averaged over the recorded evaluations, which are overlapping sliding windows and so must never be summed: a trade falls in every window that covers it.
 * @summary Report one order book's organic activity over time
 * {@link /v1/bots/organic-traffic/series}
 */
export function listOrganicTrafficSeries<ThrowOnError extends boolean = true>(
  options: Options<ListOrganicTrafficSeriesOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListOrganicTrafficSeriesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bots/organic-traffic/series',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOrganicTrafficSeriesResponses, ThrowOnError>>,
  )
}
